import {Injectable} from '@angular/core';
import {NavigationId} from '@application/helper/routing/navigation-id.enum';
import {NavigationUtils} from '@application/helper/routing/navigation-utils';
import {
  ColDefBuilderFactoryService,
  DialogBuilderFactoryService,
  GridOptionsBuilder,
  InputChipCellRendererComponent,
  LinkIconRendererComponent,
  NoDataOverlayComponentParams,
  OverlayComponentParams,
  StringUtils,
  TranslateService
} from '@vdw/angular-component-library';
import {ColDef} from 'ag-grid-community';
import {ScheduleCustomSettingsComponent} from '../settings/schedule-custom-settings.component';

@Injectable()
export class ScheduleOverviewService {
  public constructor(
    private readonly colDefBuilderFactoryService: ColDefBuilderFactoryService,
    private readonly dialogBuilderFactoryService: DialogBuilderFactoryService,
    private readonly translate: TranslateService
  ) {}

  public getColumnDefs(): ColDef[] {
    return [
      this.colDefBuilderFactoryService
        .getBuilder()
        .withHeaderName('GENERAL.NAME')
        .withColIdAndField('name', true)
        .withCellRenderer(LinkIconRendererComponent, {editPageUrl: NavigationUtils.getAbsolutePath(NavigationId.EDIT_SCHEDULE)})
        .withComparator(StringUtils.stringComparator)
        .build(),
      this.colDefBuilderFactoryService.getBuilder().withHeaderName('GENERAL.PATTERN.PATTERN', 2).withColIdAndField('patterns').withCellRenderer(InputChipCellRendererComponent).build()
    ];
  }

  public getDefaultGridOptionsBuilder(builder: GridOptionsBuilder): GridOptionsBuilder {
    return builder
      .withLoadingOverlay({
        scale: 0.7
      } as OverlayComponentParams)
      .withNoRowsOverlay({
        scale: 0.7,
        titleParam: this.translate.instant(NavigationUtils.getNavigationData(NavigationId.SCHEDULE_MODULE).navigationKey, {count: 1}),
        hideDescription: true
      } as NoDataOverlayComponentParams);
  }

  public openCustomSettings(): void {
    this.dialogBuilderFactoryService.getBuilder().withWidth('80vw').withMinWidth(900).withHeight('80vh').withMinHeight(480).openDialog(ScheduleCustomSettingsComponent);
  }
}
